import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDevices2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"devices-2, macbook, iphone, phone, connected"} maskId="square-filled-radius-0-stroke-1-IconDevices2"><path d="M23 21H16V9H23V21Z" fill="currentColor"/><path d="M15 20H1V17H15V20Z" fill="currentColor"/><path d="M21 8H15V16H3V3H21V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDevices2;
